import { Expose, Type } from 'class-transformer';
import { GetLocationSupportDto } from './get-location-support.dto';
import { GetLocationAddressDto } from './get-location-address.dto';
import { GetLocationBuildingResponseDto } from './get-location-building-response.dto';
import { GetLocationExtraInformationDto } from './get-location-extra-information.dto';

export class GetLocationResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'code' })
  code: string;
  @Expose({ name: 'lpr_type' })
  lprType?: string;
  @Expose({ name: 'gym_register_requires' })
  gymRegisterRequires: boolean;
  @Expose({ name: 'is_gym_auto_fill_enabled' })
  isGymAutoFillEnabled: boolean;
  @Expose({ name: 'is_repeatable_guests_enabled' })
  isRepeatableGuestsEnabled: boolean;
  @Expose({ name: 'support' })
  @Type(() => GetLocationSupportDto)
  support: GetLocationSupportDto;
  @Expose({ name: 'address' })
  @Type(() => GetLocationAddressDto)
  address: GetLocationAddressDto;
  @Expose({ name: 'buildings' })
  @Type(() => GetLocationBuildingResponseDto)
  buildings: GetLocationBuildingResponseDto[];
  @Expose({ name: 'extra_information' })
  @Type(() => GetLocationExtraInformationDto)
  extraInformation: GetLocationExtraInformationDto;
}
